// extracted by mini-css-extract-plugin
export default {"badgeMinWidth":"Sort_badgeMinWidth__OqIQu","DropdownToggle":"Sort_DropdownToggle__W0wPo","label":"Sort_label__g7MGn"};